import { useEffect, useLayoutEffect, useRef } from "react";

export const useDebounceUpdate = <Data>({
  execute,
  data,
  timeout = 2000,
}: {
  data: Data;
  timeout?: number;
  execute: (value: Data) => void;
}): void => {
  const isFirstRender = useRef(true);
  const executeRef = useRef(execute);
  useLayoutEffect(() => {
    executeRef.current = execute;
  });
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      executeRef.current(data);
    }, timeout);

    return () => clearTimeout(timer);
  }, [data]);
};
